import { Tooltip } from "antd";
import * as React from "react";
import { ZMdmFile, zMdmFile } from "src/types/ZMdmFile";

import { ZAttrValue } from "../../ZAttrValue";
import * as styles from "./AttrViewFiles.module.less";

type PropsAttrViewFiles = {
  value: ZAttrValue;
};

export const AttrViewFiles: React.FC<PropsAttrViewFiles> = (props) => {
  const { value } = props;
  let files: ZMdmFile[] | undefined;
  if (value.type === "array") {
    files = value.value
      ?.map((it) => zMdmFile.safeParse(it).data)
      .filter((name) => !!name);
  } else if (value.type === "file") {
    files = value.value ? [value.value] : undefined;
  }
  const count = files?.length ?? 0;
  if (count === 0) return null;
  const label = (
    <span className={styles.name}>
      {files?.[0]?.name}
      {count > 1 && ` (+${count - 1})`}
    </span>
  );
  return count === 1 ? (
    label
  ) : (
    <Tooltip
      title={
        <div>
          {files?.map((f) => (
            <div>{f.name}</div>
          ))}
        </div>
      }
      placement="bottom"
    >
      {label}
    </Tooltip>
  );
};
